import React, { useState } from 'react';
import axios from 'axios';
import * as S from './styles';
import faEnvelope from '../../icons/envelope.svg';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    const next = {};

    if (name.trim().length < 2) next.name = 'Name must be at least 2 characters.';
    const emailTrimmed = email.trim();
    if (!emailTrimmed) next.email = 'Email is required.';
    else if (!/^\S+@\S+\.\S+$/.test(emailTrimmed)) next.email = 'Enter a valid email address.';

    if (subject.trim().length < 5) next.subject = 'Subject must be at least 5 characters.';
    if (message.trim().length < 5) next.message = 'Message must be at least 5 characters.';

    return next;
  };

  const send = async () => {
    const nextErrors = validate();
    setErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      setStatus('Please fix the highlighted fields.');
      return;
    }

    setStatus('');
    setIsSubmitting(true);

    try {
      const url = 'https://satyatech.xyz:4000/video-pasal-support';
      const data = {
        name: name.trim(),
        email: email.trim(),
        query: message.trim(),
        subject: subject.trim()
      };

      const result = await axios.post(url, data);
      if (result?.data?.success === 1) {
        setStatus('Message sent successfully!');
        setName('');
        setEmail('');
        setSubject('');
        setMessage('');
        setErrors({});
      } else {
        setStatus('Could not send the message right now. Please try again.');
      }
    } catch (_e) {
      setStatus('Could not send the message right now. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <S.Contact>
      <S.Content>
        <S.NameEmail>
          <S.FieldGroup>
            <S.FieldLabel htmlFor="contact-name">Name</S.FieldLabel>
            <S.Input
              id="contact-name"
              type="text"
              value={name}
              placeholder="Enter your name"
              autoComplete="name"
              spellCheck={false}
              aria-invalid={!!errors.name}
              aria-describedby={errors.name ? 'contact-name-error' : undefined}
              onChange={e => setName(e.target.value)}
            />
            {errors.name ? <S.FieldError id="contact-name-error">{errors.name}</S.FieldError> : null}
          </S.FieldGroup>

          <S.FieldGroup>
            <S.FieldLabel htmlFor="contact-email">Email</S.FieldLabel>
            <S.Input
              id="contact-email"
              type="email"
              value={email}
              placeholder="Enter your email"
              autoComplete="email"
              spellCheck={false}
              aria-invalid={!!errors.email}
              aria-describedby={errors.email ? 'contact-email-error' : undefined}
              onChange={e => setEmail(e.target.value)}
            />
            {errors.email ? <S.FieldError id="contact-email-error">{errors.email}</S.FieldError> : null}
          </S.FieldGroup>
        </S.NameEmail>

        <S.FieldGroup>
          <S.FieldLabel htmlFor="contact-subject">Subject</S.FieldLabel>
          <S.Input
            id="contact-subject"
            type="text"
            value={subject}
            placeholder="Enter the subject"
            spellCheck={false}
            aria-invalid={!!errors.subject}
            aria-describedby={errors.subject ? 'contact-subject-error' : undefined}
            onChange={e => setSubject(e.target.value)}
          />
          {errors.subject ? <S.FieldError id="contact-subject-error">{errors.subject}</S.FieldError> : null}
        </S.FieldGroup>

        <S.FieldGroup>
          <S.FieldLabel htmlFor="contact-message">Message</S.FieldLabel>
          <S.InputMessage
            id="contact-message"
            value={message}
            placeholder="Enter your message"
            spellCheck={false}
            aria-invalid={!!errors.message}
            aria-describedby={errors.message ? 'contact-message-error' : undefined}
            onChange={e => setMessage(e.target.value)}
          />
          {errors.message ? <S.FieldError id="contact-message-error">{errors.message}</S.FieldError> : null}
        </S.FieldGroup>

        <S.ButtonRow>
          <S.Button type="button" onClick={send} disabled={isSubmitting} aria-label="Send contact message">
            <S.AIcon icon={faEnvelope} />
            <S.ButtonLabel>{isSubmitting ? 'Sending...' : 'Send'}</S.ButtonLabel>
          </S.Button>
        </S.ButtonRow>

        {status ? <S.Notice>{status}</S.Notice> : null}
      </S.Content>
    </S.Contact>
  );
}

export default Contact;
